import { v4 as createGuid } from 'uuid';

import { AttachmentType } from 'src/__generated__/graphql';
import { uploadAttachmentToS3 } from 'src/context/upload-attachments/upload-attachment-to-s3';

import { processUploadedAttachment } from './process-uploaded-attachment';

export const uploadCoverLetter = async ({
  coverLetter,
}: {
  coverLetter: File;
}) => {
  const coverLetterId = createGuid();

  return uploadAttachmentToS3({
    attachmentId: coverLetterId,
    attachment: coverLetter,
  }).then(() =>
    processUploadedAttachment({
      attachmentId: coverLetterId,
      attachmentType: AttachmentType.CoverLetter,
    }),
  );
};

export const uploadSelectionCriteria = async ({
  selectionCriteria,
}: {
  selectionCriteria: File;
}) => {
  const attachmentId = createGuid();
  return uploadAttachmentToS3({
    attachmentId,
    attachment: selectionCriteria,
  }).then(() =>
    processUploadedAttachment({
      attachmentId,
      attachmentType: AttachmentType.SelectionCriteria,
    }),
  );
};
